'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactDraggable = require('react-draggable');

var _reactDraggable2 = _interopRequireDefault(_reactDraggable);

var _shops = require('redux/modules/shops');

var _lib = require('helpers/lib');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _reactRedux = require('react-redux');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setPointRaiting(dx) {
  var widthRange = (document.getElementById('rating-bar').offsetWidth - 17) / 2;
  var step = widthRange / 10;
  var nstep = Math.round(dx / step * 10) / 10;
  var point = Math.round(nstep / 2 * 10) / 10;
  var realPoint = point + 5;
  var decPart = (realPoint + '').split('.')[1];
  var floor = Math.floor(realPoint);
  if (decPart) {
    if (decPart >= 8 || decPart >= 3) {
      // TODO: làm tròn lên 0.5 hoặc 1
      var more = decPart >= 8 ? 1 : 0.5;
      realPoint = floor + more;
    } else {
      // TODO: làm tròn xuống 0.5 hoặc 1
      realPoint = decPart < 3 ? floor : floor + 0.5;
    }
  }
  var ratingPoint = realPoint;
  if (ratingPoint <= 1) {
    ratingPoint = 1;
  }
  return {
    ratingPoint: ratingPoint,
    position: {
      x: (realPoint - 5) * step * 2,
      y: 0
    }
  };
}

var templates = {
  bad: [{ label: 'Giá cả không phù hợp', value: 'Giá cả không phù hợp' }, {
    label: 'Nhân viên tay nghề chưa chuyên nghiệp cần cải thiện',
    value: 'Nhân viên tay nghề chưa chuyên nghiệp cần cải thiện'
  }, {
    label: 'Không gian không thoải mái, sạch sẽ ',
    value: 'Không gian không thoải mái, sạch sẽ '
  }, {
    label: 'Tư vấn không nhiệt tình và hợp lý ',
    value: 'Tư vấn không nhiệt tình và hợp lý '
  }, {
    label: 'Mỹ phẩm không rõ nguồn gốc',
    value: 'Mỹ phẩm không rõ nguồn gốc'
  }, { label: 'Nhận xét khác', value: 'Nhận xét khác' }],
  normal: [{ label: 'Giá cả cũng ổn', value: 'Giá cả cũng ổn' }, { label: 'Nhân viên bình thường', value: 'Nhân viên bình thường' }, { label: 'Không gian bình thường', value: 'Không gian bình thường' }, { label: 'Tư vấn cũng ổn', value: 'Tư vấn cũng ổn' }, { label: 'Mỹ phẩm cũng ổn', value: 'Mỹ phẩm cũng ổn' }, { label: 'Nhận xét khác', value: 'Nhận xét khác' }],
  good: [{ label: 'Giá cả phù hợp', value: 'Giá cả phù hợp' }, { label: 'Nhân viên chuyên nghiệp', value: 'Nhân viên chuyên nghiệp' }, {
    label: 'Không gian thoải mái, sạch sẽ',
    value: 'Không gian thoải mái, sạch sẽ'
  }, {
    label: 'Tư vấn nhiệt tình và hợp lý',
    value: 'Tư vấn nhiệt tình và hợp lý'
  }, {
    label: 'Mỹ phẩm chất lượng, có nguồn gốc',
    value: 'Mỹ phẩm chất lượng, có nguồn gốc'
  }, { label: 'Nhận xét khác', value: 'Nhận xét khác' }]
};
var NewReview = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, { newReview: _shops.newReview }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(NewReview, _Component);

  function NewReview() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NewReview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewReview.__proto__ || (0, _getPrototypeOf2.default)(NewReview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ratingPoint: 5,
      comment: [],
      images: [],
      otherComment: '',
      mark: 1,
      errorMsg: '',
      position: { x: 0, y: 0 }
    }, _this.setComment = function (event) {
      _this.setState(function (prevState) {
        return (0, _extends3.default)({}, prevState, {
          comment: event
        });
      });
    }, _this.handleDrag = function (event, data) {
      var widthRange = document.getElementById('rating-bar').offsetWidth / 2;
      var newX = data.x;
      var temp = void 0;
      // if (newX >= 0) {
      //   temp = (newX / 265) * 5;
      // } else {
      //   temp = (newX / 265) * 4;
      // }
      temp = newX / widthRange * 5;
      var newPoint = Math.round((5 + temp) * 10) / 10;
      var result = setPointRaiting(data.x);
      _this.setState({ ratingPoint: result.ratingPoint });
      var mark = void 0;
      if (newPoint >= 0 && newPoint <= 6) {
        mark = 1;
      } else if (newPoint > 6 && newPoint < 8) {
        mark = 2;
      } else {
        mark = 3;
      }
      var comment = void 0;
      if (mark !== _this.state.mark) {
        comment = [];
        _this.setState({
          comment: comment,
          mark: mark
        });
      }
    }, _this.handleChangeOtherComment = function (event) {
      var value = event.target.value;
      _this.setState({ otherComment: value });
    }, _this.handleSubmitReview = function () {
      var shop = _this.props.shop;
      var userId = _this.props.user._id;
      var _this$state = _this.state,
          ratingPoint = _this$state.ratingPoint,
          comment = _this$state.comment,
          otherComment = _this$state.otherComment,
          images = _this$state.images;

      if (comment.length === 0) {
        alert('Vui lòng nhập nội dung bình luận.');
        return;
      }
      var hasOtherComment = false;
      var stringCmt = '';
      var firstCmt = true;
      comment.map(function (cmt) {
        if (cmt.value === 'Nhận xét khác') {
          hasOtherComment = true;
        } else if (firstCmt) {
          stringCmt += cmt.value;
          firstCmt = false;
        } else {
          stringCmt += '. ' + cmt.value;
        }
      });
      if (hasOtherComment) {
        if (firstCmt) {
          stringCmt += otherComment;
          firstCmt = false;
        } else {
          stringCmt += '. ' + otherComment;
        }
      }
      var name = (0, _lib.encrypt)((0, _lib.createImageName)({
        name: shop.name,
        type: 'review',
        user: userId
      }));
      var data = {
        shopId: shop._id,
        comment: stringCmt,
        ratingPoint: ratingPoint,
        userId: userId,
        encryptName: name
      };
      _this.props.newReview(data, images);
    }, _this.handleChangeTitle = function (event) {
      var value = event.target.value;
      _this.setState({
        title: value,
        showHint: value.length === 0 ? true : false
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NewReview, [{
    key: 'onDrop',
    value: function onDrop(acceptedFiles) {
      var totalSize = 0;
      acceptedFiles.map(function (file) {
        return totalSize += file.size;
      });
      if (totalSize > 10000000) {
        this.setState({
          errorMsg: 'Dung lượng hình ảnh quá lớn, vui lòng chọn hình ảnh có tổng dung lượng nhỏ hơn 10 MB'
        });
        return;
      }
      this.setState({ images: acceptedFiles, errorMsg: '' });
    }
  }, {
    key: 'handleStop',
    value: function handleStop(e, d) {
      var widthRange = document.getElementById('rating-bar').offsetWidth / 2;
      var step = widthRange / 10;
      var nstep = Math.round(d.x / step * 10) / 10;
      var point = Math.round(nstep / 2 * 10) / 10;
      var realPoint = point + 5;
      var decPart = (realPoint + '').split('.')[1];
      var floor = Math.floor(realPoint);
      if (decPart) {
        if (decPart >= 8 || decPart >= 3) {
          // TODO: làm tròn lên 0.5 hoặc 1
          var more = decPart >= 8 ? 1 : 0.5;
          realPoint = floor + more;
        } else {
          // TODO: làm tròn xuống 0.5 hoặc 1
          realPoint = decPart < 3 ? floor : floor + 0.5;
        }
      }
      var ratingPoint = realPoint;
      if (ratingPoint <= 1) {
        ratingPoint = 1;
      }
      var result = setPointRaiting(d.x);
      this.setState({
        ratingPoint: result.ratingPoint,
        position: result.position
      });
    }
  }, {
    key: 'handleClickRaitingBar',
    value: function handleClickRaitingBar(e) {
      var bar = document.getElementById('rating-bar');
      var widthRange = bar.offsetWidth / 2;
      var x = e.clientX - (0, _lib.getOffSetLeft)(bar);
      // Vẫn chưa hiểu lý do vì sao clientX lại lớn hơn 10 so với vị trí của div rating-bar.
      // Không thể click cho clientX bằng 0 được. Vẫn chưa hiểu rõ.
      var dx = x - widthRange;
      var result = setPointRaiting(dx);
      this.setState({
        ratingPoint: result.ratingPoint,
        position: result.position
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./NewReview.scss');
      var _state = this.state,
          ratingPoint = _state.ratingPoint,
          comment = _state.comment,
          images = _state.images,
          otherComment = _state.otherComment,
          errorMsg = _state.errorMsg;
      var _props = this.props,
          shop = _props.shop,
          averagePoint = _props.averagePoint,
          likes = _props.likes,
          totalCmt = _props.totalCmt;

      var options = void 0;
      if (ratingPoint >= 0 && ratingPoint <= 6) options = templates.bad;
      if (ratingPoint > 6 && ratingPoint < 8) options = templates.normal;
      if (ratingPoint >= 8) options = templates.good;
      var isOtherComment = false;
      comment.map(function (cmt) {
        if (cmt.value === 'Nhận xét khác') isOtherComment = true;
      });
      var thumbnailStyle = {
        background: 'url(\'' + shop.image + '\') no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
      return _react2.default.createElement(
        _reactBootstrap.Row,
        { className: styles.newReview },
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: 4, className: styles.reviewInfo },
          _react2.default.createElement('div', { className: styles.thumbnail, style: thumbnailStyle }),
          _react2.default.createElement(
            'div',
            { className: styles.ratingReview },
            averagePoint
          ),
          _react2.default.createElement(
            'div',
            { className: styles.name },
            shop.name
          ),
          _react2.default.createElement(
            'div',
            { className: styles.address },
            shop.address
          ),
          _react2.default.createElement(
            'div',
            { className: styles.likesCmt },
            _react2.default.createElement(
              'div',
              { className: styles.left },
              _react2.default.createElement(
                'span',
                { className: styles.like },
                _react2.default.createElement('i', { className: 'fa fa-heart-o ' + styles.iconLike }),
                ' ',
                likes
              ),
              _react2.default.createElement('i', { className: 'fa fa-bookmark-o ' + styles.iconCmt }),
              ' ',
              totalCmt
            ),
            _react2.default.createElement('div', { className: styles.right })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: 8, className: styles.reviewContent },
          _react2.default.createElement(
            'div',
            { className: styles.contentPoint },
            '\u0110\xE1nh gi\xE1',
            _react2.default.createElement(
              'span',
              { className: styles.point },
              ' ',
              ratingPoint.toString().length === 1 || ratingPoint === 10 ? ratingPoint.toString() + '.0' : ratingPoint
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.progressBarContainer },
            _react2.default.createElement('div', {
              className: styles.ratingBar,
              id: 'rating-bar',
              onClick: function onClick(e) {
                return _this2.handleClickRaitingBar(e);
              }
            }),
            _react2.default.createElement(
              _reactDraggable2.default,
              {
                axis: 'x',
                bounds: 'parent',
                defaultPosition: { x: 0, y: 0 },
                position: { x: this.state.position.x, y: this.state.position.y },
                onDrag: function onDrag(event, data) {
                  return _this2.handleDrag(event, data);
                },
                onStop: function onStop(e, d) {
                  return _this2.handleStop(e, d);
                }
              },
              _react2.default.createElement('div', { className: styles.selectCircle })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pointLabel },
              _react2.default.createElement(
                'div',
                { className: styles.point1 },
                '1'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.point5 },
                '5'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.point10 },
                '10'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.comment },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'N\u1ED9i dung'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              onChange: function onChange(event) {
                return _this2.setComment(event);
              },
              value: comment,
              options: options,
              multi: true,
              searchable: false,
              closeOnSelect: false,
              placeholder: 'B\xECnh lu\u1EADn'
            })
          ),
          isOtherComment && _react2.default.createElement(
            'div',
            { className: styles.comment, style: { marginTop: '20px' } },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'Nh\u1EADn x\xE9t kh\xE1c'
            ),
            _react2.default.createElement(_reactBootstrap.FormControl, {
              componentClass: 'textarea',
              placeholder: 'N\u1ED9i dung kh\xE1c',
              bsSize: 'large',
              value: otherComment,
              onChange: function onChange(event) {
                return _this2.handleChangeOtherComment(event);
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.videoImage },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'H\xECnh \u1EA3nh/Video'
            ),
            _react2.default.createElement(
              _reactDropzone2.default,
              {
                className: 'dropzone',
                onDrop: this.onDrop.bind(this),
                multiple: true,
                accept: 'image/*',
                style: { float: 'left', marginRight: '10px' }
              },
              _react2.default.createElement('div', { className: styles.addImageVideo })
            ),
            images.length > 0 && _react2.default.createElement(
              'div',
              { style: { float: 'left' } },
              images.map(function (image, index) {
                var imgBackGr = {
                  backgroundImage: 'url(' + image.preview + ')'
                };
                return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                  'div',
                  { key: image.lastModified },
                  _react2.default.createElement('video', {
                    src: image.preview,
                    key: image.lastModified + '_' + index,
                    width: '100%',
                    height: '250px',
                    controls: true
                  })
                ) : _react2.default.createElement('div', {
                  key: image.lastModified + '_' + index,
                  style: imgBackGr,
                  className: styles.thumbImage
                });
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.errorMessage },
              errorMsg
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.buttonAdd,
              onClick: function onClick() {
                return _this2.handleSubmitReview();
              }
            },
            'G\u1EECI'
          )
        )
      );
    }
  }]);
  return NewReview;
}(_react.Component), _class2.propTypes = {
  shop: _react.PropTypes.object,
  averagePoint: _react.PropTypes.number,
  user: _react.PropTypes.object,
  newReview: _react.PropTypes.func.isRequired,
  likes: _react.PropTypes.number,
  totalCmt: _react.PropTypes.number
}, _temp2)) || _class);
exports.default = NewReview;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/NewReview.js
// module id = 1644
// module chunks = 0